import React from 'react';
import { IconName, PopUp } from 'goalsetter-webapp-components';
import { useTranslation } from 'react-i18next';
import { GsErrorCode } from 'types/api/errors/enum';

interface StripeErrorModalProps {
  exception: number | undefined;
  show: boolean;
  onClose: () => void;
}

export const StripeErrorModal: React.FC<StripeErrorModalProps> = ({
  exception,
  show,
  onClose,
}) => {
  const { t } = useTranslation();
  if (exception === GsErrorCode.StripeInsufficientFundsOnPaymentMethod) {
    return (
      <PopUp
        isVisible={show}
        icon={IconName.ATTENTION}
        iconSize={80}
        title={String(t('uhOh'))}
        description={String(
          t('purchase.stripeErrorModal.balanceInsufficient.description'),
        )}
        buttonPrimaryTitle={String(
          t('purchase.stripeErrorModal.balanceInsufficient.buttonLabel'),
        )}
        onPressPrimary={onClose}
        onClose={onClose}
      />
    );
  }
  if (
    exception === GsErrorCode.DeclinedPaymentMethod ||
    GsErrorCode.CreditCardDeclined
  ) {
    return (
      <PopUp
        isVisible={show}
        icon={IconName.ATTENTION}
        iconSize={80}
        title={String(t('uhOh'))}
        description={String(
          t('purchase.stripeErrorModal.authenticationFailure.description'),
        )}
        buttonPrimaryTitle={String(
          t('purchase.stripeErrorModal.authenticationFailure.buttonLabel'),
        )}
        onPressPrimary={onClose}
        onClose={onClose}
      />
    );
  }
  if (exception === GsErrorCode.TypeOfPurchaseNotSupported) {
    return (
      <PopUp
        isVisible={show}
        icon={IconName.ATTENTION}
        iconSize={80}
        title={String(t('uhOh'))}
        description={String(
          t('purchase.stripeErrorModal.unsopported.description'),
        )}
        buttonPrimaryTitle={String(
          t('purchase.stripeErrorModal.unsopported.buttonLabel'),
        )}
        onPressPrimary={onClose}
        onClose={onClose}
      />
    );
  }
  return (
    <PopUp
      isVisible={show}
      icon={IconName.ATTENTION}
      iconSize={80}
      title={String(t('uhOh'))}
      description={String(t('purchase.stripeErrorModal.generic.description'))}
      buttonPrimaryTitle={String(
        t('purchase.stripeErrorModal.generic.buttonLabel'),
      )}
      onPressPrimary={onClose}
      onClose={onClose}
    />
  );
};
